function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import './Toolbar.css';
import cs from 'classnames';
import I18n from '../../I18n/I18n/I18n';
import StickyFill from '../../Stickyfill/Stickyfill';
import whitelistProps from '../../utils/whitelistProps';
var whitelist = whitelistProps();
var Toolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(Toolbar, _React$Component);
  function Toolbar(props) {
    var _this;
    _classCallCheck(this, Toolbar);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toolbar).call(this, props));
    _this.toggleToolbar = function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
    };
    _this.state = {
      isExpanded: false
    };
    return _this;
  }
  _createClass(Toolbar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        sticksTo = _this$props.sticksTo,
        i18n = _this$props.i18n,
        OptionsButton = _this$props.optionsButton,
        attrs = _objectWithoutProperties(_this$props, ["children", "sticksTo", "i18n", "optionsButton"]);
      var toolbarOptions = /*#__PURE__*/React.createElement("div", {
        id: "_dm-toolbar",
        className: cs('_dm-toolbar-options', {
          '_dm-toolbar-options--expanded': this.state.isExpanded,
          '_dm-toolbar-options--collapsed': !this.state.isExpanded
        })
      }, typeof children === 'function' ? children(this.toggleToolbar) : children);
      var toolbarControls = /*#__PURE__*/React.createElement("div", {
        className: "_dm-toolbar-controls"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "_dm-toolbar-controls__list"
      }, /*#__PURE__*/React.createElement("li", {
        className: "_dm-toolbar-controls__control"
      }, OptionsButton ? /*#__PURE__*/React.createElement(OptionsButton, {
        onClick: this.toggleToolbar,
        "aria-expanded": this.state.isExpanded,
        "aria-controls": "_dm-toolbar"
      }, /*#__PURE__*/React.createElement(I18n, {
        i18n: i18n
      })) : /*#__PURE__*/React.createElement("button", {
        className: "_dm-toolbar-controls__button auto-toolbar-controls__button",
        onClick: this.toggleToolbar,
        "aria-expanded": this.state.isExpanded,
        "aria-controls": "_dm-toolbar"
      }, /*#__PURE__*/React.createElement(I18n, {
        i18n: i18n
      })))));
      if (sticksTo) {
        return /*#__PURE__*/React.createElement(StickyFill, {
          sticksTo: sticksTo
        }, function (ref) {
          return /*#__PURE__*/React.createElement("div", Object.assign({
            ref: ref,
            className: "_dm-toolbar-container _dm-toolbar-container--sticky"
          }, whitelist(attrs)), /*#__PURE__*/React.createElement("div", {
            className: "_dm-toolbar-container--pinned"
          }, toolbarOptions, toolbarControls));
        });
      } else {
        return /*#__PURE__*/React.createElement("div", Object.assign({
          className: "_dm-toolbar-container"
        }, whitelist(attrs)), toolbarOptions, toolbarControls);
      }
    }
  }]);
  return Toolbar;
}(React.Component);
export { Toolbar as default };